import moment from "moment";
import React, { useContext } from "react";
import { deleteB } from "../api";
import { BookingSetContext, LanguageContext, VendorContext } from "../App";

function ModalBookingSearch({
  setStepper,
  setPopup,
  setBookingDetails,
  setTabOpen,
  bookingDetails,
}) {
  const { language } = useContext(LanguageContext);
  const { setBookingSets } = useContext(BookingSetContext);
  const details = useContext(VendorContext);

  return (
    <div id="myModal" className="modal-made">
      <div className="modal-content-made">
        <p className="header-modal">
          {language == "ltr" ? "Cannot Book" : "المحل مغلق"}
        </p>
        <p className="text-modal">
          {" "}
          {language == "ltr"
            ? "Sorry we cannot reserve due to the club being booked. Please try again using different club."
            : "عذرا لا يمكننا الحجز بسبب حجز النادي. يرجى المحاولة مرة أخرى باستخدام نادي مختلف."}
        </p>
        <div className="button-container">
          <button
            onClick={() => {
              setBookingDetails((book) => ({
                ...book,
                branch: "",
              }));
              setBookingSets((set) => ({
                ...set,
                booking_search: false,
              }));
              setTabOpen(() => 2);
              setPopup(() => false);
              setStepper(() => 0);
              deleteB({
                vendorId: details.vendor.booking_vendor_id,
                userId: localStorage.getItem("userID"),
                mainVendor:
                  details?.vendor?.home_page_type != 2 &&
                    details?.vendor?.home_page_type != 4
                    ? bookingDetails?.branch?.booking_vendor_id
                    : bookingDetails?.branch?.available_place?.[
                      bookingDetails?.place
                    ]?.booking_vendor_id,
              });
            }}
            className="green"
          >
            {language == "ltr" ? "OK" : "حسناً"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalBookingSearch;
